module.exports = __webpack_public_path__ + "media/images/emblems/Studen-coat_of_arms-8eb3327b9a930b32bf7fa0f30f3be710.svg";